/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import { connect } from 'react-redux'
import { bindActionToPromise } from '@sportninja/common/actions/utils'
import gameActions from '@sportninja/common/actions/game'
import { useEffect } from 'react'

const Signature = ({ signature = {} }) => {
  const { id, image, team_official = {}, official = {} } = signature

  return (
    <div
      css={css`
        margin: 0 8px 8px;
      `}
    >
      <h2>
        {team_official?.name_first || official?.name_first}{' '}
        {team_official?.name_last || official?.name_last}
      </h2>
      <div
        key={id}
        css={css`
          margin-top: 4px;
          position: relative;
          height: ${image?.height}px;
          width: ${image?.width}px;
          max-width: 100vw;
          background-color: white;
        `}
      >
        <img src={image?.full_path} />
      </div>
    </div>
  )
}

const DevSignatureList = ({ game, readGameSignatures }) => {
  useEffect(() => {
    readGameSignatures(game.id)
  }, [game.id])
  const hasEndGameSignatures =
    Array.isArray(game.signatures) && game.signatures.length > 0
  return (
    <div>
      <h2>Team Roster Signatures</h2>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
        }}
      >
        {Array.isArray(game?.playerRosters) &&
          game.playerRosters.map((roster) => {
            const signatures = roster?.signatures
            return signatures?.map((signature) => {
              return <Signature key={signature?.id} signature={signature} />
            })
          })}
      </div>
      {hasEndGameSignatures && <h2>Game Official Signatures</h2>}
      {hasEndGameSignatures &&
        game.signatures.map((signature) => {
          return <Signature key={signature?.id} signature={signature} />
        })}
    </div>
  )
}

const mapDispatchToProps = (dispatch) => {
  return {
    readGameSignatures: bindActionToPromise(
      dispatch,
      gameActions.readSignatures.request
    ),
  }
}

export default connect(null, mapDispatchToProps)(DevSignatureList)
